import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  Gauge, ArrowsLeftRight, Bank, UsersThree, CalendarCheck, Money,
  ChartLineUp, Sparkle, SignOut, List, X, CurrencyGbp
} from "@phosphor-icons/react";
import { useState } from "react";

const NAV = [
  { to: "/dashboard", label: "Genel Bakış", icon: Gauge, testid: "nav-dashboard" },
  { to: "/transactions", label: "Gelir & Gider", icon: ArrowsLeftRight, testid: "nav-transactions" },
  { to: "/bank-accounts", label: "Banka Hesapları", icon: Bank, testid: "nav-banks" },
  { to: "/contacts", label: "Cari Hesaplar", icon: UsersThree, testid: "nav-contacts" },
  { to: "/payments", label: "Ödeme & Tahsilat", icon: CalendarCheck, testid: "nav-payments" },
  { to: "/checks", label: "Çekler", icon: Money, testid: "nav-checks" },
  { to: "/exchange-rates", label: "Döviz Kurları", icon: CurrencyGbp, testid: "nav-rates" },
  { to: "/reports", label: "Raporlar", icon: ChartLineUp, testid: "nav-reports" },
  { to: "/insights", label: "AI Analiz", icon: Sparkle, testid: "nav-insights" },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);

  const SidebarContent = () => (
    <div className="flex flex-col h-full">
      <div className="flex items-center gap-3 px-6 h-16 border-b border-border shrink-0">
        <div className="w-9 h-9 rounded-md bg-primary flex items-center justify-center">
          <ChartLineUp size={20} weight="bold" className="text-white" />
        </div>
        <span className="font-display text-lg font-semibold">Kasa<span className="text-primary">Flow</span></span>
      </div>
      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            data-testid={item.testid}
            onClick={() => setOpen(false)}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors duration-200 ${
                isActive
                  ? "bg-primary/15 text-primary"
                  : "text-muted-foreground hover:text-foreground hover:bg-secondary"
              }`
            }
          >
            <item.icon size={20} weight="regular" />
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-border">
        <div className="flex items-center gap-3 px-3 py-2">
          <img
            src={user?.picture || "https://images.pexels.com/photos/20157010/pexels-photo-20157010.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=100&w=100"}
            alt="avatar"
            className="w-9 h-9 rounded-full object-cover border border-border"
          />
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium truncate">{user?.name}</p>
            <p className="text-xs text-muted-foreground truncate">{user?.email}</p>
          </div>
          <button
            data-testid="logout-button"
            onClick={logout}
            className="text-muted-foreground hover:text-destructive transition-colors duration-200"
          >
            <SignOut size={20} />
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen flex bg-background">
      <aside className="hidden lg:block w-64 border-r border-border fixed inset-y-0 left-0 bg-card z-30">
        <SidebarContent />
      </aside>

      {open && (
        <div className="lg:hidden fixed inset-0 z-40">
          <div className="absolute inset-0 bg-black/60" onClick={() => setOpen(false)} />
          <aside className="absolute inset-y-0 left-0 w-64 bg-card border-r border-border">
            <SidebarContent />
          </aside>
        </div>
      )}

      <div className="flex-1 lg:ml-64 min-w-0">
        <header className="lg:hidden h-16 border-b border-border flex items-center justify-between px-4 sticky top-0 bg-background z-20">
          <button data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)} className="p-2">
            {open ? <X size={22} /> : <List size={22} />}
          </button>
          <span className="font-display font-semibold">KasaFlow</span>
          <div className="w-8" />
        </header>
        <main className="p-4 sm:p-6 lg:p-8">{children}</main>
      </div>
    </div>
  );
}
